module.exports = __webpack_public_path__ + "static/media/ellipse.54d9683e.svg";